module.exports = __webpack_public_path__ + "static/media/assyrian_text_07.cc1469d5.jpg";